import React from 'react';
import { Input, Select, Button, Row, Col, Radio, Checkbox, DatePicker, Icon } from 'antd';
import SelectPlaceHolder from '../../../components/SelectPlaceHolder';
import moment from 'moment';
const { Option } = Select;
const InputGroup = Input.Group;
class Filters extends React.Component {
    render() {
        return (
            <div className="filfer-container">
                <Row gutter={16}>

                    <Col className="gutter-row" sm={24} md={12} lg={7}>
                        <Input
                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            value={this.props.filter.referencia}
                            onChange={(e) => this.props.onChange("referencia", e.target.value)}
                            placeholder="Filtrar por nombre o codigo referencia"
                            autoComplete="off"
                            onKeyUp={this.props.onKeyUpSearch}

                        />
                    </Col>
                    {/* 
                    <Col className="gutter-row" sm={24} md={12} lg={8}>
                        <InputGroup compact>
                            <Select showSearch labelInValue
                                value={this.props.filter.idProducto ? { key: this.props.filter.idProducto } : undefined}
                                style={{ width: `calc(100% - 40px)` }}
                                placeholder={"Búsqueda de Productos"}
                                optionFilterProp="children"
                                showArrow={false}
                                onSearch={this.props.onSearchAutocomplete}
                                onChange={this.props.onChangeAutocomplete}
                            >
                                {this.props.productos.map(item => (
                                    <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                ))}
                            </Select> 
                            <Button
                                className="btn-autocomplete"
                                style={{ width: '40px', fontSize: '14px' }}
                                icon={this.props.filter.idProducto ? 'close' : 'search'}
                                onClick={this.props.onClearAutocomplete}
                            />
                        </InputGroup>
                    </Col>
 */}
                    <Col className="gutter-row" sm={24} md={12} lg={5}>
                        <Select
                            showSearch labelInValue
                            value={this.props.filter.idEstablecimiento ? { key: this.props.filter.idEstablecimiento } : undefined}
                            placeholder={<SelectPlaceHolder label="Filtrar por establecimiento" />}
                            onChange={(option) => this.props.onChange("idEstablecimiento", option.key)} //STATE PROPERTY
                            optionFilterProp="children"
                            loading={this.props.establecimientosLoading}
                        >

                            {this.props.establecimientos.map(item => (
                                <Select.Option value={item.id} key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={4}>
                        <Select
                            showSearch labelInValue
                            value={this.props.filter.idAlmacen ? { key: this.props.filter.idAlmacen } : undefined}
                            placeholder={<SelectPlaceHolder label="Filtrar por almacén" />}
                            onChange={(option) => this.props.onChange("idAlmacen", option.key)}
                            optionFilterProp="children"
                            loading={this.props.monedasLoading}
                        >
                            <Option key={'0'} value={'0'}>
                                <span>Todos</span>
                            </Option>
                            {this.props.almacenes.map(item => (
                                <Select.Option value={item.id} key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>

                    <Col className="gutter-row" sm={24} md={24} lg={6}>
                        <div style={{ height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center' }} >
                            <Radio.Group
                                value={this.props.filter.tipoReporte}
                                onChange={(e) => this.props.onChange("tipoReporte", e.target.value)}
                            >
                                <Radio value={1}>General</Radio>
                                <Radio value={2}>Resumen</Radio>
                                <Radio value={3}>Detallado</Radio>
                            </Radio.Group>
                        </div>
                    </Col>

                    <Col className="gutter-row" sm={24} md={24} lg={4}>
                        <div style={{ height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center' }} >

                            <Checkbox
                                defaultChecked={this.props.filter.incluirNotaVenta}
                                onChange={(e) => this.props.onChange("incluirNotaVenta", e.target.checked)}
                            >Incluir Nota de Venta</Checkbox>

                        </div>
                    </Col>

                    {this.props.filter.tipoReporte == 3 ?
                        <>
                            <Col className="gutter-row" sm={24} md={12} lg={3}>
                                <DatePicker
                                    placeholder="Filtrar por fecha inicio"
                                    format="DD/MM/YYYY"
                                    value={this.props.filter.fechaDesdeFormat === '' ? null : moment(this.props.filter.fechaDesdeFormat, 'DD/MM/YYYY')}
                                    onChange={(moment, value) => this.props.onChange('fechaDesdeFormat', value)}
                                />
                            </Col>
                            <Col className="gutter-row" sm={24} md={12} lg={3}>
                                <DatePicker
                                    placeholder="Filtrar por fecha fin"
                                    format="DD/MM/YYYY"
                                    value={this.props.filter.fechaHastaFormat === '' ? null : moment(this.props.filter.fechaHastaFormat, 'DD/MM/YYYY')}
                                    onChange={(moment, value) => this.props.onChange('fechaHastaFormat', value)}
                                />
                            </Col>
                        </> :
                        <Col className="gutter-row" sm={24} md={12} lg={3}>
                            <DatePicker
                                placeholder="Filtrar por fecha inicio"
                                format="DD/MM/YYYY"
                                value={this.props.filter.fechaFormat === '' ? null : moment(this.props.filter.fechaFormat, 'DD/MM/YYYY')}
                                onChange={(moment, value) => this.props.onChange('fechaFormat', value)}
                            />
                        </Col>
                    }



                </Row>
            </div>
        );
    }
}

export default Filters;